import { __extends } from "tslib";
import { InstrumentationBase } from '@opentelemetry/instrumentation';
import { trace } from '@opentelemetry/api';
import { SpanStatusCode } from '@opentelemetry/api';
import { hrTime } from '@opentelemetry/core';
import getRouteName from './get-route-name';
var ClientErrorInstrumentation = /** @class */ (function (_super) {
    __extends(ClientErrorInstrumentation, _super);
    function ClientErrorInstrumentation(routes, version) {
        var _this = _super.call(this, 'client-error', version, {}) || this;
        _this.enabled = false;
        _this._routes = routes;
        return _this;
    }
    // override unnecessary init
    ClientErrorInstrumentation.prototype.init = function () { };
    ClientErrorInstrumentation.prototype.onReport = function (event, eventType) {
        var _a;
        var _b;
        var now = hrTime();
        var routeName = getRouteName(this._routes);
        var tracer = trace.getTracer('client-error-instrumentation');
        var clientErrorSpan = tracer.startSpan("".concat(eventType, " error"), {
            startTime: now,
        });
        clientErrorSpan.setStatus({ code: SpanStatusCode.ERROR, message: event.message });
        clientErrorSpan.setAttributes((_a = {},
            _a["site.page"] = routeName,
            _a["client_error.message"] = event.message,
            _a["client_error.stack"] = (_b = event.error) === null || _b === void 0 ? void 0 : _b.stack,
            _a["client_error.href"] = location.href,
            _a["client_error.userAgent"] = navigator.userAgent,
            _a));
        clientErrorSpan.end();
    };
    ClientErrorInstrumentation.prototype.enable = function () {
        var _this = this;
        if (this.enabled) {
            return;
        }
        this.enabled = true;
        var onError = function (event) {
            _this.onReport(event, 'uncaught');
        };
        var onLogError = function (log) {
            var event = {
                message: typeof log === 'string' ? log : log.message,
            };
            _this.onReport(event, 'console');
        };
        window.addEventListener('error', onError);
        var consoleError = console.error;
        console.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var logData = args.length > 1 ? args.join(' ') : args[0];
            onLogError(logData);
            consoleError.apply(void 0, args);
        };
    };
    return ClientErrorInstrumentation;
}(InstrumentationBase));
export { ClientErrorInstrumentation };
//# sourceMappingURL=client-error-instrumentation.js.map